/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Ermrouter_Page_Rolemanagement2Inputs */

const en__ermrouter_page_rolemanagement2 = /** @type {(inputs: _Ermrouter_Page_Rolemanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Management`)
};

/**
* | output |
* | --- |
* | "Role Management" |
*
* @param {_Ermrouter_Page_Rolemanagement2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _ermrouter_page_rolemanagement2 = /** @type {((inputs?: _Ermrouter_Page_Rolemanagement2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Ermrouter_Page_Rolemanagement2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__ermrouter_page_rolemanagement2(inputs)
});
export { _ermrouter_page_rolemanagement2 as "_ermRouter_page_roleManagement" }